import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { IconButton, Icon, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ContributionBudgetForm from './ContributionBudgetForm'
import ContributionBudgetTable from './ContributionBudgetTable'
import { getOther, saveOther, updateOther, deleteOther } from '../../../../redux/actions/budget'
import { startLoading, doneLoading } from '../../../../utils/loading'
import { getSchemaSidebar } from '../../../../redux/actions/sidebar'
import WarningMessage from '../../../../components/message/WarningMessage/WarningMessage'

export default function ContributionBudgetWidgets({ shaded = true, ...props }) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  // const { showCommandButton, isEditAll } = props
  const [section, setSection] = useState()
  // const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  // useEffect(() => {
  //   setIsEdit(isEditAll)
  // }, [isEditAll])

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateOther(projectId, request)
      } else {
        console.log('call save.')
        response = await saveOther(projectId, request)
      }
      if (response) {
        setFormSchema(response)
        setIsError(false)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schama) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await deleteOther(projectId, schama.id)
      if (status === 200) {
        const _schema = await getOther(projectId)
        setFormSchema(_schema)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let dataList = [...formSchema.value]

    let id
    if (data.selectedIndex != -1) {
      id = dataList[data.selectedIndex].id
    }

    let request = {
      id: id,
      projectVersionId: projectId,
      userId: 111,
      organization: data.organization,
      budget: data.budget,
      otherSupport: data.otherSupport,
    }

    console.log('request', request)

    handleUpdateSave(request)
  }

  const onDelete = (index) => {
    let dataList = [...formSchema.value]
    handleDelete(dataList[index])
  }

  const onBackToView = () => {
    console.log('onBackToView', formSchema.value)

    setFormSchema((state) => ({
      ...state,
    }))
    setIsError(false)
    setIsDeleteError(false)
    onChangeIsEdit(!isEdit)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  return (
    <Panel
      shaded={shaded}
      header={formSchema.header}
      collapsible
      defaultExpanded
      bordered
      ref={(section) => {
        setSection(section)
      }}
    >
      <div style={{ marginTop: -10 }}>
        <WarningMessage message={formSchema?.feedbackBySubject} />

        {isEdit && showCommandButton ? (
          <ContributionBudgetForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onSubmit={handleSubmit(onSubmit)}
            onDelete={onDelete}
            isError={isError}
            isDeleteError={isDeleteError}
            loading={isLoading}
          />
        ) : (
          <>
            <ContributionBudgetTable schema={formSchema} />
          </>
        )}
      </div>

      {showCommandButton && (
        <>
          <hr />

          {isEdit ? (
            <div>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
                onClick={onBackToView}
              >
                {'กลับไปดู ' +
                  (formSchema.contributionBudgetText ? formSchema.contributionBudgetText : '')}
              </IconButton>
            </div>
          ) : (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                // console.log(!isEdit)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
            >
              {'แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </IconButton>
          )}
        </>
      )}
    </Panel>
  )
}
